export default __webpack_public_path__ + "static/media/Insta.001bcb51.svg";